import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { TextAreaContainer } from '@/components/inputs/TextAreaContainer'
import { ScopeChangeRequestRejectDialog } from '@/features/admin/scope-change-requests/ScopeChangeRequestRejectDialog'
import {
  ScopeChangeRequestRejectDialogViewModel,
  type ScopeChangeRequestRejectVariant,
} from './ScopeChangeRequestRejectDialogViewModel'

const reasonTestIds: Record<ScopeChangeRequestRejectVariant, string> = {
  Decline: 'scope-change-request-decline-reason',
  RejectOnBehalfOfClient: 'scope-change-request-client-decline-reason',
}

export interface ScopeChangeRequestRejectDialogContainerProps {
  vm: ScopeChangeRequestRejectDialogViewModel
}

export const ScopeChangeRequestRejectDialogContainer = observer(
  function ScopeChangeRequestRejectDialogContainer({
    vm,
  }: ScopeChangeRequestRejectDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <ScopeChangeRequestRejectDialog
        variant={vm.variant}
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onReject={vm.reject}
        isRejectPending={vm.reject.pending}
        corporateMode={shellInfo.corporateMode}
        reasonField={
          <TextAreaContainer
            rows={4}
            model={vm}
            field="reason"
            name="reason"
            maxLength={
              ScopeChangeRequestRejectDialogViewModel.MAX_REASON_LENGTH
            }
            error={vm.validation.getError('reason')}
            status={vm.validation.getError('reason') ? 'danger' : 'default'}
            placeholder="This will be visible to everyone"
            help={`${vm.reasonCharsRemaining} characters remaining`}
            data-test={reasonTestIds[vm.variant]}
          />
        }
      />
    )
  },
)
